(function () {
  const STORAGE_KEY = 'mc_evergreen_timer';

  function getTimerData() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setTimerData(durationSeconds) {
    const data = {
      start: Date.now(),
      duration: durationSeconds * 1000
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
    return data;
  }

  function clearTimerData() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function getRemainingMs(data) {
    return data.start + data.duration - Date.now();
  }

  function pad(n) {
    return String(Math.floor(n)).padStart(2, '0');
  }

  function renderTime(ms, el) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    el.querySelector('#mc-timer-days').textContent = days;
    el.querySelector('#mc-timer-hours').textContent = pad(hours);
    el.querySelector('#mc-timer-minutes').textContent = pad(minutes);
    el.querySelector('#mc-timer-seconds').textContent = pad(seconds);
  }

  function showExpired(el) {
    if (el.dataset.mode === 'fixed') {
      el.style.display = 'none';
      var promoPrice = document.querySelector('.mc-countdown-promo-price');
      if (promoPrice) promoPrice.style.display = 'none';
      return;
    }
    var promoPrice = document.querySelector('.mc-countdown-promo-price');
    if (promoPrice) promoPrice.style.display = 'none';
    var hide = ['.mc-evergreen-timer__display', '.mc-evergreen-timer__badge', '.mc-evergreen-timer__description'];
    hide.forEach(function(sel) {
      var node = el.querySelector(sel);
      if (node) node.style.display = 'none';
    });
    el.querySelector('.mc-evergreen-timer__expired').style.display = '';
  }

  function startCountdown(getRemainingFn, el) {
    var remaining = getRemainingFn();
    if (remaining <= 0) {
      renderTime(0, el);
      showExpired(el);
      return;
    }

    renderTime(remaining, el);

    var interval = setInterval(function () {
      remaining = getRemainingFn();

      if (remaining <= 0) {
        clearInterval(interval);
        renderTime(0, el);
        showExpired(el);
        return;
      }

      renderTime(remaining, el);
    }, 1000);
  }

  function initFixedMode(el) {
    var endDateStr = el.dataset.endDate;
    if (!endDateStr) {
      showExpired(el);
      return;
    }

    var endTime = new Date(endDateStr.replace(' ', 'T')).getTime();
    if (isNaN(endTime)) {
      showExpired(el);
      return;
    }

    startCountdown(function () {
      return endTime - Date.now();
    }, el);
  }

  function initEvergreenMode(el) {
    var durationSeconds = parseInt(el.dataset.duration, 10);
    if (!durationSeconds || isNaN(durationSeconds)) return;

    var data = getTimerData();

    if (!data) {
      data = setTimerData(durationSeconds);
    } else {
      var durationChanged = data.duration !== durationSeconds * 1000;
      var remaining = getRemainingMs(data);
      if (remaining <= 0 || durationChanged) {
        clearTimerData();
        data = setTimerData(durationSeconds);
      }
    }

    startCountdown(function () {
      return getRemainingMs(data);
    }, el);
  }

  function initCodeTooltip(el) {
    var codeEl = el.querySelector('.mc-evergreen-timer__promo-code');
    if (!codeEl) return;

    var code = codeEl.dataset.code;
    if (!code) return;

    var tooltip = document.createElement('span');
    tooltip.className = 'mc-code-tooltip';
    tooltip.textContent = 'Click to copy';
    codeEl.appendChild(tooltip);

    codeEl.addEventListener('click', function () {
      var done = function () {
        tooltip.textContent = 'Code copied!';
        codeEl.classList.add('mc-evergreen-timer__promo-code--copied');
        setTimeout(function () {
          codeEl.classList.remove('mc-evergreen-timer__promo-code--copied');
          tooltip.textContent = 'Click to copy';
        }, 2000);
      };

      var copied = false;
      try {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        copied = document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) {}

      if (copied) {
        done();
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      }
    });
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
  }

  function updatePromoPrice(variant, discountPct) {
    var promoEl = document.querySelector('.mc-countdown-promo-price');
    if (!promoEl) return;
    var promoPrice = Math.round(variant.price * (100 - discountPct) / 100);
    var strong = promoEl.querySelector('strong');
    if (strong) strong.textContent = formatMoney(promoPrice);
    promoEl.style.display = '';
  }

  function initEvergreenTimer() {
    var el = document.querySelector('.mc-evergreen-timer');
    if (!el) return;

    var discountPct = parseInt(el.dataset.discountPercentage, 10) || 0;

    if (el.offsetParent !== null) {
      var promoEl = document.querySelector('.mc-countdown-promo-price');
      if (promoEl) promoEl.style.display = '';
    }

    if (discountPct > 0 && typeof subscribe === 'function') {
      subscribe('variant-change', function(event) {
        var variant = event.data && event.data.variant;
        if (!variant) return;
        updatePromoPrice(variant, discountPct);
      });
    }

    initCodeTooltip(el);

    var mode = el.dataset.mode;

    if (mode === 'fixed') {
      initFixedMode(el);
    } else {
      initEvergreenMode(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEvergreenTimer);
  } else {
    initEvergreenTimer();
  }
})();
